// src/components/Section/RWOSection.jsx

import React from "react";
import ModalImage from "react-modal-image";

const RWOSection = ({ members }) => {
  if (!Array.isArray(members)) {
    return (
      <div className="bg-white px-4 py-12 max-w-6xl mx-auto text-center">
        <h2 className="text-xl font-bold text-blue-700 mb-10 uppercase">
          RWO - REGIONAL WELLNESS OFFICERS
        </h2>
        <p className="text-gray-600">No data available.</p>
      </div>
    );
  }

  return (
    <div className="bg-white px-4 py-12 max-w-6xl mx-auto text-center">
      {/* Section Title */}
      <h2 className="text-3xl font-bold text-blue-700 mb-10 uppercase">
        RWO - REGIONAL WELLNESS OFFICER<span className="lowercase">s</span>
      </h2>

      <div className="border-1 rounded-lg border-[#307bc4] p-4">
        {/* Members Grid */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 p-4">
          {members.map((member, index) => (
            <div key={index} className="text-center">
              {/* ✅ Desktop: clickable fullscreen */}
              <div className="hidden lg:block cursor-pointer">
                <ModalImage
                  small={member.img || "https://via.placeholder.com/250x320?text=No+Image"}
                  large={member.img || "https://via.placeholder.com/250x320?text=No+Image"}
                  alt={member.name || ""}
                  className="w-[250px] h-[320px] mx-auto object-cover border-2 border-blue-400 rounded-3xl shadow-md transition-transform duration-300 hover:scale-105"
                />
              </div>

              {/* ✅ Mobile/Tablet: static image */}
              <div className="block lg:hidden">
                <img
                  src={member.img || "https://via.placeholder.com/250x320?text=No+Image"}
                  alt={member.name || ""}
                  className="w-[250px] h-[320px] mx-auto object-cover border-2 border-blue-400 rounded-3xl"
                />
              </div>

              {/* Name & Designation */}
              <div className="font-semibold text-blue-800 mt-2 text-sm uppercase">
                {member.name || ""}
              </div>

              {member.designation && (
                <div className="text-blue-600 text-sm font-medium">
                  {member.designation}
                </div>
              )}

              {/* Optional content */}
              {member.content && (
                <div className="mt-[10px] text-gray-700">{member.content}</div>
              )}
            </div>
          ))}
        </div>

        {/* Vacancy Note */}
        {/* <div className="mt-10 mx-auto w-fit rounded text-[#274760] font-semibold md:text-lg border-4 border-[#307bc4] p-4">
          Currently 25 RWO posts are{" "}
          <span className="text-red-600 text-2xl font-bold">VACANT</span> for
          various States of India.
        </div> */}
      </div>
    </div>
  );
};

export default RWOSection;
